import type { TroopKit } from "../kit/types";

/**
 * The Night Watch troop skin (Black Market, epic band; contract tools/art/skins/README.md §Troops). Its own soldier,
 * `art/hq/troop_soldier__nightwatch.glb` (+ `_lod1`), built on the unit kit by tools/art/skins/troops.py
 * (art/unitkit/units_troops_v2.py + anim_troopskins.py; troops v2 2026-10-27: gold on the cowl, the cloak's hem and
 * collar, a crest clasp and a crest on the cloak's back, real metal, the one troop body scale) at the stock soldier's scale and rig: a
 * deep peaked black cowl with a long liripipe over a blued-steel visor whose T-slit glows cold blue, blued-steel plate
 * with silver trim, a long black cloak in two cloth parts, a glaive with a curved blade and a glowing rune, a buckler,
 * and a witch-light lantern held out in the left hand (part `lantern`). Its own clips: the lantern watch (`idle`: held
 * low and swinging, then raised high while the hood turns to peer about), a glaive twirl (`fidget`), a stalking prowl,
 * a diagonal glaive sweep and a rising thrust; the lantern hangs and swings through every one.
 * `fx` (kit/troopFx.ts): the lantern's cold light pooled on the ground under it (flickering), a cold-blue ribbon behind
 * the glaive's point through each blow with a frost glint as it lands, and pale motes rising off the lantern.
 * `fallback`: the legacy cloak tint while the model is not in the manifest.
 */
export const NIGHTWATCH: TroopKit = {
  id: "troop.nightwatch",
  model: "troop_soldier__nightwatch",
  fallback: { tint: 0x2f2f40, mix: 0.66, gain: 0.85, keepAccents: false, roughness: 0.4, trim: { colour: 0x6cc8ff, strength: 0.7 } },
  fx: {
    pool: { node: "lantern", at: [0, -0.024, 0], colour: 0x5aa8ff, width: 0.62, strength: 0.6, flicker: 0.28, hz: 2.3 },
    strike: {
      tip: [0.015, 0.206, -0.031],
      trail: { colour: 0x8ccfff, width: 0.055, bright: 1.35, lead: 0.13, after: 0.08, seg: 0.03 },
      glint: { colour: 0xc4e8ff, count: 3 },
    },
    idle: { node: "lantern", at: [0, -0.024, 0], kind: "motes", colour: 0x9fd4ff, count: 2, every: [3, 6] },
  },
};
